export const getOrderedSignatoriesMap = (signatories) => signatories.reduce((acc, signatory) => {
    const order = signatory.order || 0;
    const mapArray = acc[order] || [];
    return Object.assign(Object.assign({}, acc), { [order]: [...mapArray, signatory] });
}, {});
